<template>
  <div class="main">
       <div class="x-subnav">
      <xy-toolbox-menu class="l" :items="equipMenu" current="装备率"  />
       <div  class="r action-btn-box" v-show="!viewResult">
           <el-button @click="gotoEquipmentRateAnalysis"  type="primary" :disabled="searchResult.length==0"  class="actionBtn"  round >装备率分析 <svg-icon name="play" size="12" ></svg-icon> </el-button> 
        </div>
      <xy-toolbox-menu class="r" v-show="viewResult">
        <xy-toolbox-menu-item icon="car_search" @click="goto">返回</xy-toolbox-menu-item>
        <xy-toolbox-menu-item icon="date" @click="modifyDate">调整时间</xy-toolbox-menu-item>
        <xy-toolbox-menu-item icon="excel" @click="exportExcel">Excel导出</xy-toolbox-menu-item>
      </xy-toolbox-menu>
    </div>
    <SearchBar :moduleName="currentModuleName" v-if="!viewResult">
  
    </SearchBar>
    <div v-if="viewResult" class="view-main">

      <div style="padding-right:40px;">
      <el-table :data="tableData" border height="650" style="width: 98%; margin:20px 10px 10px 10px;">
        <el-table-column prop="tag" label="装备分类" align="center" width="180"> </el-table-column>
        <el-table-column prop="name" label="装备名称"></el-table-column>
        <el-table-column prop="val" label="装备名称"></el-table-column>
        <el-table-column align="center" label="装备率">
          <el-table-column icon="el-icon-search" align="center" :prop="n" :key="n" :label="n" v-for='n in date_list'>
          </el-table-column>
        </el-table-column>
      </el-table>
      </div>
    </div>
    <el-dialog title="修改时间" :visible.sync="showModifyDate" :center="false" :append-to-body="true">
      <span slot="dialog-title"> </span>
      <el-row>
        <el-col :span="24" type="flex" justify="end">
          <el-date-picker v-model="currentMonth" type="month" placeholder="选择月" value-format="yyyy-M"> </el-date-picker> &nbsp;&nbsp;
          <el-button icon="el-icon-plus" @click="addDate">添加</el-button>
        </el-col>
      </el-row>
      <div>
        <ul class="date-list">
          <li :prop="n" :key="n" :label="n" v-for='(n,index) in date_list_tmp'>{{n}}
            <el-button size="small" icon="el-icon-delete" circle type="danger" class="r-delete-btn" @click="removeDate(index)"> </el-button>
          </li>
        </ul>
      </div>
      <span slot="footer">
                  <el-button  type="primary" @click="updateData">更新数据</el-button>
              </span>
    </el-dialog>
  </div>
</template>
<script>
  import {
    mapMutations,
    mapGetters,
    mapActions
  } from 'vuex';
  import SearchBar from '@/components/common/NewSearchBar.vue';
  //import mock_data from '../../store/mock/installedratiomock.js';
  export default {
    name: 'EquipmentRateAnalysis',
    components: {
      SearchBar
    },
    data() {
      return {
        tableCfg: null,
        viewResult: false,
        showModifyDate: false,
        currentMonth: '',
        currentModuleName: 'EquipmentRateAnalysis',
        tableData: [],
        date_list: [],
        date_list_tmp: [],
        models:[],
      }
    },
    methods: {
      ...mapActions('equipanalysis', [
        'queryInstalledRatios'
      ]),
      toPercent(point) {
        if (point == 0) {
          return 0;
        }
        var str = Number(point * 100).toFixed(2);
        str += "%";
        return str;
      },
      goto() {
        this.viewResult = !this.viewResult;
      },
      removeDate(index) {
        this.date_list_tmp.splice(index, 1);
      },
      addDate() {
        if (this.currentMonth.trim() == '') {
              this.$message({
                message:  '日期不能为空',
                duration: 2000,   
            });

           return ;

        }
         
       if (this.date_list_tmp.findIndex(x=>x ==this.currentMonth)>0)
         {
              this.$message({
                message:  '日期已存在',
                duration: 2000,   
            });

           return ;
         }
         

        this.date_list_tmp.push(this.currentMonth);
      },
      modifyDate() {
        this.date_list_tmp = [];
        this.date_list_tmp.push(...this.date_list);
        this.showModifyDate = true;
      },
      updateData() {
        this.showModifyDate = false;
        this.date_list = [];
        this.date_list.push(...this.date_list_tmp);
        this.gotoEquipmentRateAnalysis();
      },
      exportExcel() {
        JSONToExcel(this.tableData, "report");
      },
      praseTable() {
        let len = this.tableData.length;
        //获取大分类  
        var categories = new Set(this.tableData.map(x => {
          return x.tag;
        }));
        console.log(categories);
        var dict = new Map();
        categories.forEach(function(value) {
          dict.set(value, {
            startIndex: 10000000,
            endIndex: 0
          });
        });
        var tableCfg = [...categories].map(x => {
          return {
            name: x,
            startIndex: 0,
            endIndex: 0
          }
        });
        for (var i = 0; i < len; i++) {
          let key = this.tableData[i].tag;
          var di = dict.get(key);
          if (di.endIndex < i) {
            di.endIndex = i;
          }
          if (di.startIndex > i) {
            di.startIndex = i;
          }
        }
        this.tableCfg = dict;
      },
      objectSpanMethod({
        row,
        column,
        rowIndex,
        columnIndex
      }) {
        var cfg = this.tableCfg.get(row.tag);
        if (columnIndex === 0) {
          let count = cfg.endIndex - cfg.startIndex + 1;
          if (rowIndex === cfg.startIndex) {
            return {
              rowspan: count,
              colspan: 1
            };
          } else if (rowIndex > cfg.startIndex && rowIndex <= cfg.endIndex) {
            return {
              rowspan: 0,
              colspan: 0
            };
          }
        }
      },
      setViewResult(isShow) {
        this.viewResult = isShow;
      },
      gotoEquipmentRateAnalysis() {

         var ms = this.searchResult.filter((item, index) => {
          return this.searchResult.findIndex((obj) => {
            return obj.modeId === item.modeId;
          }) === index;
        }).map(x => x.model);
        this.models = ms;
       // alert(JSON.stringify(ms));
        var postData = {
          models: ms,
          date_list: this.date_list
        };
        this.queryInstalledRatios({
          params: postData,
          handle: this.setViewResult
        });
      },
      bindTable() {
        this.tableData = [];
        for (var item of this.installedRatioList) {
          var data = {
            tag: item.tag,
            name: item.name,
            val: item.val
          };
          var i = 0;
          for (var dt of this.date_list) {
            data[dt] = this.toPercent(item.data[i].ratio);
            i++;
          }
          this.tableData.push(data);
        }
        this.praseTable();
      },
    },
    created() {
      var myDate = new Date();
      var month = myDate.getFullYear() + "-" + (myDate.getMonth() + 1);
      this.date_list.push(month);
    },
    computed: {
      ...mapGetters('equipanalysis', {'installedRatioList': 'installedRatioList'
      }),
      ...mapGetters('commonsearch', {
        'searchResult': 'selectionResult',
        'savedResultSchemas': 'savedResultSchemas',
        'pivotTableKey': 'pivotTableKey',
        'showSubmodel': 'showSelectionSubmodel'
      }),
    },
    mounted() {
    },
    watch: {
      viewResult(value) {
        if (value) {
          this.bindTable();
        }
      },
      installedRatioList(value) {
        this.bindTable();
      }
    }
  }
</script>
 